import { CheckCircleOutlined, CloseCircleOutlined, SmileOutlined, TeamOutlined } from '@ant-design/icons'
import { Avatar, Col, Empty, List, Row } from 'antd'
import { isNil } from 'lodash'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { UserHoverCard } from '@/components'
import {
  WorkCircleStatus,
  useGetUserWorkCircleQuery,
  useUserInfoWorkCircleFeedBackUpdateMutation,
} from '@/generated/graphql'
import { useLayoutSize } from '@/hooks/layout-size.hooks'
import { routes } from '@/routes'

import { UserInfoSectionLayout } from './user-info-section-layout/user-info-section-layout.component'
import { UserInfoProps } from './user-info.interface'
import s from './user-info.module.less'

export const UserInfoWorkCircle: React.FC<UserInfoProps> = ({ userId, readonly }) => {
  const history = useHistory()
  const { t } = useTranslation()
  const [hasGivenFeedback, setHasGivenFeedback] = React.useState(false)

  const { isMobileSize } = useLayoutSize()

  const { data } = useGetUserWorkCircleQuery({
    variables: {
      userId,
    },
  })

  const [feedbackUpdate] = useUserInfoWorkCircleFeedBackUpdateMutation({
    onCompleted() {
      setHasGivenFeedback(true)
    },
  })

  const workCircles = data?.user.workCircle?.users.slice() || []
  const status = data?.user.workCircle.status
  const feedback = data ? data.user.basicProfile.workCircleFeedback : true
  const shouldGivenFeedBack = workCircles.length > 0
  const createdAt = data ? moment(data.user.basicProfile.createdAt) : moment()

  const showNoticeMessage = !readonly || (workCircles?.[0] || []).length > 0
  const showFeedback =
    isNil(feedback) && !readonly && !isMobileSize && shouldGivenFeedBack && status === WorkCircleStatus.Success

  const emptyMessage = (() => {
    switch (status) {
      case WorkCircleStatus.Update:
        return t('user.info.updateCircleMessage')
      case WorkCircleStatus.Fail:
        return t('user.info.failCircleMessage')
      case WorkCircleStatus.Success:
      default:
        return t(`user.info.${moment().diff(createdAt, 'month') <= 3 ? 'newEmpty' : 'empty'}WorkCircleMessage`)
    }
  })()

  const onClick = (feedback: boolean) => {
    feedbackUpdate({ variables: { feedback } })
  }

  const workCirclePart = (
    <div className={s.workCircle}>
      <div>
        {showNoticeMessage && (
          <span style={{ color: '#65676b', fontSize: 14, margin: '4px 0' }}>
            {readonly
              ? `和 TA 协作最密切 Top ${(workCircles?.[0] || []).length}`
              : `按密切关系排序的同事圈子 - 数据不准？有优化意见可以提给大数据算法团队哦~`}
          </span>
        )}
      </div>
      {workCircles.length > 0 ? (
        <List
          dataSource={workCircles}
          renderItem={(workCircle, index) => (
            <List.Item>
              <div className={s.colleagues}>
                {!readonly && (
                  <span
                    style={{ marginRight: 8, fontSize: 15, fontWeight: 600, display: 'inline-block', marginBottom: 8 }}
                  >{`${t('user.info.workCircle')} ${(index + 10).toString(36).toUpperCase()}`}</span>
                )}
                <Row style={{ display: 'flex', flexWrap: 'wrap', margin: 0 }}>
                  {workCircle.map((user) => (
                    <Col xl={6} key={user.userId}>
                      <UserHoverCard email={user.email}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            marginRight: 40,
                            marginTop: 8,
                            cursor: 'pointer',
                          }}
                          onClick={() => history.push(routes.users.page(user.userId))}
                        >
                          <Avatar size={36} src={user.avatarUrl} key={user.userId} style={{ flexShrink: 0 }} />
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'space-between',
                              flex: 1,
                            }}
                          >
                            <span style={{ fontSize: 12, color: '#000000d9' }}>{user.name}</span>
                            {user.departments?.[0]?.name ? (
                              <span style={{ fontSize: 12, color: '#00000073' }}>{user.departments?.[0]?.name}</span>
                            ) : (
                              <span>&#160;</span>
                            )}
                          </div>
                        </div>
                      </UserHoverCard>
                    </Col>
                  ))}
                </Row>
              </div>
            </List.Item>
          )}
        />
      ) : (
        <Empty description={<span>{emptyMessage}</span>} />
      )}
    </div>
  )
  return (
    <UserInfoSectionLayout
      title={
        <div>
          <span>{t('user.info.workCircle')}</span>
          <span style={{ color: '#65676b', fontSize: 14, margin: '0 4px' }}>Beta</span>
        </div>
      }
      icon={<TeamOutlined />}
      actions={
        showFeedback &&
        (hasGivenFeedback ? (
          <div>
            <SmileOutlined style={{ marginRight: 4 }} />
            <span>感谢您的反馈！</span>
          </div>
        ) : (
          <div className={s.workCircleActions}>
            <span>{'您的工作圈是否准确 ?'}</span>
            <CheckCircleOutlined onClick={() => onClick(true)} />
            <CloseCircleOutlined onClick={() => onClick(false)} />
          </div>
        ))
      }
      showActions={true}
    >
      {workCirclePart}
    </UserInfoSectionLayout>
  )
}
